<template>
<div>
    <div class="registration-form-ec">
        
        <div class="form-wrap form-control-wrapper row align-items-center"> <a href="" class="back-btn"><i class="fas fa-arrow-left"></i></a>
            <div class="bg_white form-box">
                <div class="w100 center mb-3">
                    <img src="../../assets/images/kriyana.png" width="200">
                </div>
                <form id="otp_form" class=" w100 mt-2 " method="post" autocomplete="off">
                    <div v-if="!userRegistered">
                        <label>Name</label>
                        <input class="w100" v-model="name">
                        <label>Select City </label>
                        <select class="w100 mb-3 mt-2" v-if="noOfStores==0" v-model="selectedCity" @change="loadCityStores($event)" style="border:1px solid #ddd;padding:10px">
                            <option disabled>{{selectedCity}}</option>
                            <option v-for="item in cityList" :key="item.city" :value="item.city">{{item.city}}</option>
                        </select>
                        
                    </div>

                    <label class="mt-2">Select Store </label>
                    <select class="w100 mt-2" v-model="selectedStore" style="border:1px solid #ddd;padding:10px">
                        <option v-for="item in storeList" :key="item.store_name" :value="item">{{item.store_name}}</option>
                        <option disabled>{{selectedStore.store_name}}</option>
                    </select>
                    <div class="mt-3 form-control-wrapper">
                        <input type="button" @click="submitStore()" value="Goto Store" class="text-center form-btn">
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import ApiList from '../ApiList'
export default {
    components: {},
    name: 'verifyOtp',

    mixins: [ApiList],
    data() {
        return {
            customer_id: '',
            mobile: '',
            name: '',
            userRegistered: false,
            selectedCity: 'Select City',
            cityList: [],
            storeList: [],
            selectedStore: "Select Store",
            noOfStores: 0,
        }
    },
    mounted() {
        if (localStorage.noOfStores == 1) {
            this.$router.push('/home');
        }
        this.loadData();
    },
    methods: {
        loadCityStores(evt) {
            console.log("load stores" + evt.target.value)
            this.customer_id = localStorage.customer_id
            this.newUrl = this.apis.apiUrl + this.apis.shopkeeperDetails;
            this.param = {
                params: {
                    token: this.apis.token,
                    city: this.selectedCity
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    this.storeList = response.data
                });
        },
        fetchStores() {
            this.customer_id = localStorage.customer_id
            this.newUrl = this.apis.apiUrl + this.apis.checkUserStores;
            this.param = {
                params: {
                    token: this.apis.token,
                    customer_id: this.customer_id
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    this.storeList = response.data
                    console.log("store List" + JSON.stringify(this.storeList))
                    this.userRegistered = true
                });
        },
        fetchCities() {
            this.newUrl = this.apis.apiUrl + this.apis.chooseCity;
            this.param = {
                params: {
                    token: this.apis.token,
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    this.cityList = response.data
                    console.log("city List" + JSON.stringify(this.cityList))
                });
        },

        loadData() {
            this.noOfStores = localStorage.getItem("noOfStores")
            if (this.noOfStores == 0) {
                this.userRegistered = false
            } else {
                this.userRegistered = true
            }
            this.mobile = localStorage.getItem("tmp_mobile")
            this.name = localStorage.getItem("tmp_name");
            this.referral_code = localStorage.getItem("referral_code");

            if (this.noOfStores == 0) {
                this.fetchCities()
                this.userRegistered = false
            } else {
                this.fetchStores()
            }

        },

        selectStore() {
            // console.log('store selecetd here ' + JSON.stringify(this.selectedStore))
            this.newUrl = this.apis.apiUrl + this.apis.chooseStoreUrl;
            this.param = {
                params: {
                    token: this.apis.token,
                    db: this.selectedStore.database_name,
                }
            }
            var mapUrl = this.apis.apiUrl + this.apis.mapCustomer
            var map_param = {
                params: {
                    token: localStorage.getItem("token"),
                    customer_id: window.btoa(this.customer_id)
                }
            }
            var updateNameUrl = this.apis.apiUrl + this.apis.updateCustomerName
            var updateName_param = {
                params: {
                    token: localStorage.getItem("token"),
                    customer_id: window.btoa(this.customer_id),
                    name: window.btoa(this.name)
                }
            }

            axios.get(this.newUrl, this.param)
                .then((response) => {
                    // console.log("hit api--->" + JSON.stringify(response))
                    if (localStorage.noOfStores == 0) {
                        // hit api to map Customer

                        axios.get(mapUrl, map_param)
                            .then((response1) => {
                                console.log(response1)
                            })
                        // hit api to update Customer Name
                        localStorage.setItem("name",this.name)
                        axios.get(updateNameUrl, updateName_param)
                            .then((response2) => {
                                console.log(response2)
                            })

                    }
                    if (response.data.store_id != '' && response.data.store_name != '') {
                        localStorage.setItem('store_name', response.data.store_name);
                        localStorage.setItem('selected_db', this.selectedStore.database_name);
                        localStorage.setItem('store_id', response.data.store_id);
                        localStorage.setItem('token', response.data.token);

                        if (localStorage.getItem('selected_db') != null) {
                            this.$router.push('/home');
                        }
                    } else {
                        alert("Error in Store Selection.")
                        this.$router.push('/');
                    }

                });

        },
        submitStore() {
            this.selectStore()

        }

    },
}
</script>
